import { AuctionInfo } from "../stores/auctionStore"

export default (auctionInfo: AuctionInfo) => {
    return Math.round(((parseInt(auctionInfo.auction_state.mint_pot) / auctionInfo.in_play_tokens.length) / parseInt(auctionInfo.configs.nft_price)) * 100) / 100
}